import React from "react"
import Container from '@material-ui/core/Container'
import {ThemeProvider} from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline';
import RBTheme from './reedBasketTheme'
import './i18n';
import { makeStyles } from '@material-ui/core/styles';
import AppBarLandingPage from './appBarLandingPage'


const useStyles = makeStyles(theme => ({
sectionDesktop: {
    position: "fixed",
  //  margin: "0 auto",
    width: "100%",
    top: '0px',
    zIndex:"2",
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'inline-block',
      maxWidth: '95%'
    },
  },
  sectionMobile: {
    display: 'flex',
    position: "fixed",
    margin: "0 auto",
    width: "100%",
    top: '0px',
    zIndex:"2",
    [theme.breakpoints.up('md')]: {
      display: 'none',
    }
  },

  children:{
        marginTop: "70px",
        
  }
 
}))

export default ({ children }) => {
    let classes = useStyles();
    return (
        <ThemeProvider theme={RBTheme}>
        
         <CssBaseline/>
        
        <Container disableGutters={true}>
          <AppBarLandingPage />
          
         
          <div className={classes.children}>  
            {children}
          </div>  
        </Container>
       </ThemeProvider>
    )
}